import { Modal } from '../ui/Modal';

interface Props {
  close: () => void;
  onClick: () => void;
  text: string;
  btnText: string;
  className?: string;
}

export const SecurityModal = ({ close, onClick, text, btnText, className }: Props) => {
  return (
    <Modal title="Are you sure?" onClose={close} boxClassName={className}>
      <p>{text}</p>
      <div className="flex gap-4 mt-6">
        <button type="submit" className="secondaryBtn w-full" onClick={onClick}>
          {btnText}
        </button>
        <button type="button" className="secondaryBtn w-full" onClick={close}>
          Cancel
        </button>
      </div>
    </Modal>
  );
};
